import { EnumWithDescription, ICustomEnumValue } from "./EnumWithDescription";

export enum TypeOfRecordEnum {
    "Medical Record" = 1,
    "Administered While on Service" = 2,
    "Verbalized by Patient or Caregiver" = 3
}

class TypeOfRecordClass extends EnumWithDescription<TypeOfRecordEnum> {
    public readonly enum = TypeOfRecordEnum;
    public readonly enumName: string = "TypeOfRecordEnum";

    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<TypeOfRecordEnum>> = new Map([
        [
            "Medical Record",
            {
                name: "Medical Record",
                value: TypeOfRecordEnum["Medical Record"]
            }
        ],
        [
            "Administered While on Service",
            {
                name: "Administered While on Service",
                value: 2
            }
        ],
        [
            "Verbalized by Patient or Caregiver",
            {
                name: "Verbalized by Patient or Caregiver",
                value: 3
            }
        ]
    ]);
}

export const TypeOfRecord = new TypeOfRecordClass();
